import { post, get,postJson,deleteApi,put, } from '../axios'

const RESOURCE_BASE_PATH = '/intelligent-marketing/api/'

export const getIntelligentList = p => get(`${RESOURCE_BASE_PATH}`, p);

export const updateIntelligent = p => postJson(`${RESOURCE_BASE_PATH}`, p);

// 查询所有模板接口
export const getAllTemplateList = p => get(`${RESOURCE_BASE_PATH}getAllTemplateList`, p);

// 删除自定义模板接口
export const delCustomizeT = p => get(`${RESOURCE_BASE_PATH}delCustomizeTemplate/${p}`)

// 创建智能营销活动
export const addSmartMarketing = p => postJson(`${RESOURCE_BASE_PATH}saveActivity`, p)

// 删除智能营销活动
export const delSmartMarketing = p => deleteApi(`${RESOURCE_BASE_PATH}${p}`);

// 另存模板
export const saveTemplate = p => postJson(`${RESOURCE_BASE_PATH}saveTemplate`, p);

// 分页查询智能营销短信记录
export const getSmsRecordPage = p => get(`${RESOURCE_BASE_PATH}sms-record/page`, p);

// 取消发送
export const cancelSendSms = p => postJson(`${RESOURCE_BASE_PATH}sms-record/cancel`, p);

// 查询智能营销短信记录下拉框
export const getSmsRecordDown = p => get(`${RESOURCE_BASE_PATH}sms-record/list/${p}`);

// 获取活动节点最小等待时间
export const getMinWaitTime = p => get(`${RESOURCE_BASE_PATH}getMinWaitTime`, p);
